import { render, staticRenderFns } from "./SingleAd.vue?vue&type=template&id=0448a762&scoped=true&"
import script from "./SingleAd.vue?vue&type=script&lang=js&"
export * from "./SingleAd.vue?vue&type=script&lang=js&"
import style0 from "./SingleAd.vue?vue&type=style&index=0&id=0448a762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0448a762",
  null
  
)

export default component.exports